import { ICommand } from "./ICommand";

export class CommandSet<T, TCommand extends ICommand<T> = ICommand<T>> implements ICommand<T> {
  constructor(commands?: TCommand[]) {
    this._commands = commands
      ? commands
      : [];
  }

  protected _commands: TCommand[];

  do(target: T): void {
    for (const command of this._commands) {
      command.do(target); 
    }
  }
}
